import { Controller } from "@hotwired/stimulus";
import GtagService from "../../services/GtagService";

export default class extends Controller {
  static values = {
    eventName: String,
    params: { type: Object, default: {} },

    once: { type: Boolean, default: false },

    onceScope: { type: String, default: "session" },
  };

  click(event) {
    const rawHref = this.element.tagName === "A" ? this.element.getAttribute("href") : null;
    const href = rawHref || null;

    if (href) {
      event.preventDefault();
    }

    if (this.onceValue && this.alreadyFired()) {
      if (href) {
        window.location.href = href;
      }
      return;
    }

    if (this.onceValue) {
      this.onceStorage.setItem(this.onceStorageKey, "1");
    }

    GtagService.gtagEventAndNavigate({
      event: this.eventNameValue,
      params: this.paramsValue,
      targetUrl: href,
    });
  }

  alreadyFired() {
    return this.onceStorage.getItem(this.onceStorageKey) === "1";
  }

  get onceStorage() {
    return this.onceScopeValue === "user" ? localStorage : sessionStorage;
  }

  get onceStorageKey() {
    return `gtag_once_${this.eventNameValue}`;
  }
}
